<template>
  <div v-if="show && scrollMessages.length" class="scroll-messages" :style="customStyle">
    <div class="scroll-messages-inner" ref="scrollInner">
      <div class="message-list"
        :style="{ transform: `translateY(${scrollOffset}vw)`, transition: isTransitioning ? 'transform 0.5s ease' : 'none' }">
        <div v-for="(msg, index) in scrollMessages" :key="index" class="message-item">
          {{ truncateNickname(msg.nickname) }}{{ msg.action }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { chttp } from '@/libs/interfaces';

export default {
  name: 'ScrollMessages',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    customStyle: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      scrollMessages: [],
      scrollOffset: 0,
      currentIndex: 0,
      scrollTimer: null,
      isTransitioning: true,
    };
  },
  watch: {
    show(newVal) {
      if (newVal) {
        this.fetchScrollMessages();
      } else {
        this.stopScroll();
      }
    }
  },
  methods: {
    truncateNickname(name) {
      if (!name) return '';
      return name.length > 4 ? `${name.slice(0, 4)}...` : name;
    },
    async fetchScrollMessages() {
      try {
        const res = await chttp.get('/vodc/sei/top40');
        if (res.errcode === 200 && res.data.orders) {
          this.scrollMessages = res.data.orders;
          this.startScroll();
        }
      } catch (e) {
        console.error('获取滚动消息失败:', e);
      }
    },
    startScroll() {
      if (this.scrollTimer) {
        clearInterval(this.scrollTimer);
      }

      const scrollStep = () => {
        this.currentIndex++;
        this.scrollOffset = -this.currentIndex * 8.533;

        // 当滚动到第一组消息的末尾时，立即重置到开始位置
        if (this.currentIndex >= this.scrollMessages.length) {
          // 先移除过渡动画
          this.isTransitioning = false;
          // 立即重置位置
          this.currentIndex = 0;
          this.scrollOffset = 0;
          // 在下一帧恢复过渡动画
          requestAnimationFrame(() => {
            this.isTransitioning = true;
          });
        }
      };

      // 每1.5秒滚动一次
      this.scrollTimer = setInterval(scrollStep, 1500);
    },
    stopScroll() {
      if (this.scrollTimer) {
        clearInterval(this.scrollTimer);
        this.scrollTimer = null;
      }
    }
  },
  mounted() {
    if (this.show) {
      this.fetchScrollMessages();
    }
  },
  beforeDestroy() {
    this.stopScroll();
  }
};
</script>

<style lang="scss" scoped>
.scroll-messages {
  width: 460px;
  height: 8.533vw;
  margin: 30px auto;
  border-radius: 32px;
  background: #111111;
  overflow: hidden;
  position: absolute;
  top: -160px;
  left: 145px;

  .scroll-messages-inner {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .message-list {
    position: absolute;
    width: 100%;
  }

  .message-item {
    height: 8.533vw;
    line-height: 8.533vw;
    text-align: center;
    color: rgba(255, 255, 255, 0.6);
    font-size: 28px;
    white-space: nowrap;
  }
}
</style>
